module.exports = __webpack_public_path__ + "media/email-unsubscribe/unsub-bb9ae405.png";